export default __webpack_public_path__ + "59fc40298aea038bcc09bd3202623fb3.png";